import { ASubheaderProps } from '../../atoms/ASubheader/ASubheader.types';
import { AIconProps } from '../../atoms/AIcon/AIcon.types';

export enum MSocialGroupOrientation {
  Vertical = 'Vertical',
  Horizontal = 'Horizontal',
}

export type MSocialGroupIconInteractive = {
  aIcon: AIconProps;
  ctaLink: string;
  openInANewTab: string | boolean;
};

export type MSocialGroupProps = {
  orientation?: MSocialGroupOrientation;
  aSubheader?: ASubheaderProps;
  mIconInteractive?: MSocialGroupIconInteractive[];
  onNavigate: (url: string, openInANewTab: boolean) => void;
};
